const getUser = (user) => user || {};

export const isInternalUser = (user) => {
    const { email = '' } = getUser(user);

    // until junedjabbar1990 get perpetualpress email
    return email.endsWith('@perpetualpress.io') || email.endsWith('@getpoln.com') ||  email === 'junedjabbar1990@gmail.com'
}

export const hasRole = (user, role) => {
    const { roles = [] } = getUser(user);

    const _roles = new Set(roles);

    return _roles.has(role) || (role === 'Admin' && isInternalUser(user));
}
